import React from 'react';

import './Button.progress.scss';

function ButtonProgress({ children, type, className, handleClick, disabled, inProgress }) {
    const listenClick = () => {
        if (!!handleClick) {
            handleClick();
        }
    }

    return (
        <button onClick={listenClick} className={`button ${className || ''}`} type={type || null} disabled={!!disabled}>
            <div className={`progressButton ${inProgress ? 'submitting' : ''}`}>
                {inProgress ? <div className="_progressing"></div> : ''}
                {children}
            </div>
        </button>
    )
}

export default ButtonProgress;